import { render, staticRenderFns } from "./chart_widgets.vue?vue&type=template&id=378604ad&"
import script from "./chart_widgets.vue?vue&type=script&lang=js&"
export * from "./chart_widgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports